import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import LocationPinIcon from "@mui/icons-material/LocationPin";
import type { FC } from "react";
import EntityCard from "../../components/entityCard/EntityCard";
import type { ProductResponse } from "./productsApi";

interface Props {
  readonly value: Pick<ProductResponse, "id" | "name" | "contact">;
  readonly onClick: () => void;
  readonly onContextMenu: () => void;
}

export function getGoogleMapsPlaceUrl(placeId: string): string {
  return `https://www.google.com/maps/place/?q=place_id:${placeId}`;
}

const ProductCard: FC<Props> = ({ value, onClick, onContextMenu }) => {
  return (
    <EntityCard role="ADMIN" onClick={onClick} onContextMenu={onContextMenu}>
      <Stack
        direction="row"
        sx={{
          width: "100%",
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
          }}
        >
          <Typography variant="subtitle1">{value.name}</Typography>
        </Box>
        <Box>
          {value.contact.googlePlaceId ? (
            <Tooltip title="Zobacz na mapie">
              <IconButton
                href={getGoogleMapsPlaceUrl(value.contact.googlePlaceId)}
                target="_blank"
                aria-label="Zobacz na mapie"
                onClick={(e) => e.stopPropagation()}
              >
                <LocationPinIcon />
              </IconButton>
            </Tooltip>
          ) : null}
        </Box>
      </Stack>
    </EntityCard>
  );
};

export default ProductCard;
